import camelcaseKeysDeep from 'camelcase-keys-deep';
import normalize from '@/lib/normalize';
import RootStateCommit from '@/store/mixins/rootstate-commit';

const DEFAULT_STATE = {
  data: [],
  loading: false,
  error: null,
  currentPage: 1,
  totalPages: 1,
  nextPage: null,
  prevPage: null,
  totalCount: null,
  filters: {}
};

function PaginatedListStore(resource, customOptions = {}, moduleName = 'paginatedList') {
  return {
    state: { ...customOptions.state, ...DEFAULT_STATE },

    /* eslint no-param-reassign: ["error", { "props": false }] */
    mutations: {
      ...customOptions.mutations,
      setPage(state, page) {
        state.currentPage = page;
      },
      startLoading(state) {
        state.loading = true;
      },
      parseResponseData(state, data) {
        const { currentPage, totalPages, nextPage, prevPage, totalCount } = camelcaseKeysDeep(
          data.meta
        );
        state.data = normalize(data);
        state.currentPage = currentPage;
        state.totalPages = totalPages;
        state.nextPage = nextPage;
        state.prevPage = prevPage;
        state.totalCount = totalCount;
        state.loading = false;
      },
      setResponseError(state) {
        state.loading = false;
        state.error = 'Something went wrong';
      },
      resetStore(state) {
        Object.assign(state, DEFAULT_STATE);
      },
      setFilters(state, filters) {
        state.filters = filters;
      }
    },
    getters: { ...customOptions.getters },
    actions: {
      ...customOptions.actions,
      async fetchPage({ commit, state }, payload = {}) {
        const { options, ...rest } = payload;
        const fetchUrl = typeof resource === 'function' ? resource(options) : resource;

        if (rest.page == null) {
          rest.page = { number: state.currentPage };
        } else if (typeof rest.page === 'number') {
          rest.page = { number: rest.page };
        }

        if (rest.q) {
          commit('setFilters', rest.q);
        } else {
          rest.q = state.filters;
        }

        if (rest.size) {
          rest.page.size = rest.size;
        }

        commit('setPage', rest.page.number);
        commit('startLoading');

        RootStateCommit(commit, 'startLoading', moduleName);

        try {
          const response = await fetchUrl.get(rest);

          if (!response) throw Error;

          commit('parseResponseData', response.data);

          RootStateCommit(commit, 'stopLoading', moduleName);
        } catch (error) {
          commit('setResponseError');
          RootStateCommit(commit, 'setResponseError', moduleName);
          RootStateCommit(commit, 'stopLoading', moduleName);
        }
      }
    }
  };
}

export default PaginatedListStore;
